import React, { useState, useRef } from "react";
import "./contentpage.css";
import Question from "../components/Question";
import LandingSection from "./LandingSection";
import FloatingPageNav from "../components/FloatingPageNav";



function IslamicGuide69() {

  const contentRef = useRef(null);
  const titleText = "Bitcoin & Obedience to the Muslim Ruler";
  const links = {
    prev: "/islamicguide-68",
    index: "/index-islamicguide",
    next: "/islamicguide-70",
  };
  
  const questions = [
  {
    text: "1. According to Islamic teachings, what is the Muslim’s duty towards their ruler?",
    options: [
      { value: "A", label: "A. To always oppose them in worldly matters" },
      { value: "B", label: "B. To listen, obey, pray for them, and advise them when needed" },
      { value: "C", label: "C. To follow them only if they are wealthy" },
      { value: "D", label: "D. To ignore their commands in financial matters" },
    ],
    correct: "B",
  },
  {
    text: "2. According to Islamic principles, what is the role of free markets?",
    options: [
      { value: "A", label: "A. That rulers should dictate every financial decision" },
      { value: "B", label: "B. That commerce is not important in Islam" },
      { value: "C", label: "C. That Muslims should not engage in trade" },
      { value: "D", label: "D. That Islam allows free markets guided by halal and haram principles" },
    ],
    correct: "D",
  },
  {
    text: "3. How does Bitcoin reflect the Islamic principle of free market activity?",
    options: [
      { value: "A", label: "A. By fixing its price through government decrees" },
      { value: "B", label: "B. By letting its value be determined by the market itself" },
      { value: "C", label: "C. By letting issuance and value be determined by the market itself" },
      { value: "D", label: "D. By allowing manipulation by central authorities" },
    ],
    correct: "C",
  },
  {
    text: "4. How should Muslims view Bitcoin in relation to their rulers?",
    options: [
      { value: "A", label: "A. As a tool to rebel against the Muslim state" },
      { value: "B", label: "B. As a financial tool that supports sovereignty while maintaining obedience to rulers" },
      { value: "C", label: "C. As a replacement for rulers in governance" },
      { value: "D", label: "D. As a tool to avoid paying taxes" },
    ],
    correct: "B",
  },
];

  // State to track selected answers for all questions
  const [answers, setAnswers] = useState({});

  // Function to update an answer
  const handleAnswerChange = (questionIndex, selectedValue) => {
    setAnswers((prev) => ({ ...prev, [questionIndex]: selectedValue }));
  };

  // Compute score
  const score = questions.reduce((total, q, index) => {
    return total + (answers[index] === q.correct ? 1 : 0);
  }, 0);
  

 

  return (
    <div className="container">
     <LandingSection
        titleText={titleText}
        scrollToRef={contentRef}
        progressValue={69}
        timerMinutes={60}
        currentLevel={5}
        unlockedBadges={11}
      />

      <p className="content" ref={contentRef}>
        Welcome to <b>Day 69</b>! Today we will explore the important balance
        between financial sovereignty and obedience to Muslim rulers. Islam has
        always emphasized the duty of Muslims to listen to, obey, and support
        their leaders in matters of piety and righteousness, while also
        recognizing the freedom of individuals in trade and commerce as long as
        they remain within the bounds of the Quran and Sunnah. Bitcoin aligns
        with this principle by allowing a free market to determine its value,
        without interference from a single authority. However, some mistakenly
        interpret this as a justification for rebellion or rejection of
        legitimate rulers, which is far removed from Islamic teachings. Today’s
        discussion will clarify how Bitcoin can strengthen Islamic governance
        rather than weaken it, reminding us that obedience to rulers is an
        integral part of faith.
        <br />
        <br />
        <b>The Principle of Obedience to Muslim Rulers in Islam</b>
        <br />
        <br />
        Islam is a religion that combines worship of Allah with order,
        structure, and discipline in the affairs of human society. From the
        Qur’an to the Sunnah, Muslims are commanded to obey their rulers in all
        matters that do not involve disobedience to Allah. The Qur’an says,
        <br />
        “O you who believe, obey Allah, obey the Messenger, and those in
        authority among you.” (Surah An-Nisa 4:59).
        <br />
        This verse establishes a clear framework: authority is recognized,
        obedience is required, and cooperation with the ruler is essential for
        the stability of the Ummah. The Prophet Muhammad (peace be upon him)
        also taught his companions to listen and obey their rulers even when
        they faced hardship, as long as the ruler did not command them to
        disobey Allah. This guidance shows us that rebellion, chaos, and
        undermining the ruler are not Islamic traits, for they destroy the unity
        of the Muslim community and open the door to fitnah.
        <br />
        At the same time, Islamic obedience is not blind servitude. The Prophet
        himself laid out the boundaries of authority, reminding Muslims that
        rulers are also accountable before Allah and that their role is to
        uphold justice, protect religion, and safeguard the welfare of the
        people. Companions were encouraged to advise rulers with wisdom and
        sincerity if they saw shortcomings, but never to destabilize the Ummah.
        This balance between obedience and accountability created the model of
        leadership that was first implemented by the Prophet himself, then by
        the four righteous caliphs, and later by many Muslim rulers across
        history. Within this system, obedience to rulers was tied to the broader
        vision of establishing justice and upholding Islamic principles in
        society.
        <br />
        <br />
        <b>Islam, Free Markets, and the Boundaries of Ruler Intervention</b>
        <br />
        <br />
        One of the most profound aspects of Islam is its recognition of human
        needs in worldly affairs and its encouragement of free markets. The
        Prophet Muhammad (peace be upon him) himself once told his companions,
        “You are more knowledgeable about your worldly matters.” This statement
        was not an abdication of leadership but rather a recognition that
        worldly commerce and trade thrive best when left to the participants of
        the market, as long as they adhere to the moral and ethical boundaries
        set by the Qur’an and Sunnah. This guidance prevents rulers from
        overstepping into areas where individual choice, effort, and risk-taking
        should prevail.
        <br />
        Bitcoin aligns closely with this principle. Its issuance is not
        controlled by any ruler, government, or central bank. Instead, it is
        determined by a transparent, open network where rules are based on
        verifiable mathematics and computer science. No one can arbitrarily
        inflate its supply or manipulate its value, as often happens with fiat
        currencies. The value of Bitcoin is discovered in the free market, where
        participants willingly exchange it based on their understanding of its
        utility, scarcity, and reliability. This is not a violation of the
        ruler’s authority but rather a reaffirmation of the Islamic principle
        that markets must be free, provided they operate within ethical
        guidelines.
        <br />
        Historically, Muslim markets during the time of the Prophet and the
        rightly guided caliphs were characterized by openness and freedom.
        Traders from different regions gathered, competition flourished, and
        participants determined prices through supply and demand. The role of
        the ruler was not to fix prices arbitrarily or monopolize trade but to
        ensure honesty, prevent fraud, and prohibit riba. The ruler’s
        responsibility was to enforce justice and prevent exploitation, not to
        dictate every detail of economic activity. The marketplace was
        considered a sacred space where fair competition and transparency were
        safeguarded, and this contributed to the flourishing of Islamic
        civilization.
        <br />
        <br />
        <b>Misinterpretations of Bitcoin as a Tool for Rebellion</b>
        <br />
        <br />
        Despite the harmony between Bitcoin and Islamic principles of free
        markets, there are groups of people who misinterpret Bitcoin as a tool
        for rebellion against legitimate rulers. These individuals claim that since Bitcoin
        operates outside the authority of governments and rulers, it should be
        used to undermine them or to reject their legitimacy altogether.
        Unfortunately, some Muslims have also been influenced by this deviant
        ideology, mistaking financial sovereignty for political disobedience.
        <br />
        Bitcoin should instead be understood as a tool that can strengthen the
        position of Muslim rulers by enabling them to build economies free of
        riba and independent of the control of external powers. A ruler who
        adopts Bitcoin for his state is not weakened but rather empowered, for
        he leads his people with a sound monetary foundation. Similarly, Muslims
        who use Bitcoin within their societies do not weaken their rulers; they
        support them by participating in an economy that is just and
        sustainable.
        <br />
        This way of thinking is far removed from the guidance of Islam. The
        Prophet Muhammad (peace be upon him) explicitly forbade Muslims from
        rebelling against their rulers, even when the rulers committed
        injustices, as long as they did not commit open disbelief. He warned
        that rebellion leads to chaos, bloodshed, and division, all of which are
        greater harms than the injustice of a flawed ruler. Rebellion is only
        permitted when a ruler openly rejects Islam, not for matters of policy,
        trade, or economic disagreement. Thus, to use Bitcoin as a justification
        for rejecting rulers is an innovation with no basis in Islam.
        <br />
        <br />
        <b>
          Bitcoin as a Tool of Financial Sovereignty Under Legitimate Authority
        </b>
        <br />
        <br />
        When viewed correctly, Bitcoin emerges as a tool that strengthens
        Islamic governance rather than undermining it. Unlike fiat money, which
        is built on riba and endless debt, Bitcoin is capped in supply, free of
        inflationary manipulation, and created through proof of work that
        reflects real effort and energy. These qualities make it a just and
        stable foundation for economic systems. If Muslim rulers adopt Bitcoin
        as part of their financial infrastructure, they can lead their societies
        away from riba, protect the wealth of their citizens, and build
        economies that are resilient and independent of global fiat hegemony.
        This vision is entirely compatible with obedience to rulers. A Muslim
        who adopts Bitcoin still fulfills all his religious obligations to his
        state. He pays zakah, gives sadaqah and charity when the ruler calls for
        it, and participates in the welfare of the Ummah. Bitcoin does not
        exempt him from his duties; it simply provides a just medium of wealth
        that ensures his contributions are meaningful and protected from the
        distortions of inflation. Instead of weakening the state, Bitcoin can
        make it stronger, as its financial base will no longer be built upon
        riba and the whims of central planners.
        <br />
        Muslims must be careful not to fall into the trap of deviant ideologies
        that equate Bitcoin with rebellion. The truth is the opposite: Bitcoin,
        when adopted within the Islamic framework, upholds the values of
        justice, fairness, and accountability. It allows rulers to govern with
        financial integrity, empowers citizens to save and invest responsibly,
        and removes the distortions of fiat that harm societies. In this way,
        Bitcoin becomes a means of cooperation between rulers and ruled,
        ensuring both financial sovereignty and social harmony.
        <br />
        Bitcoin is not a threat to the legitimacy of Muslim rulers. Rather, it
        is a tool that can restore the integrity of financial systems under
        their authority. It affirms the principle of obedience to rulers while
        ensuring that markets remain free, ethical, and just. Muslims must
        embrace Bitcoin with this balanced understanding, using it to strengthen
        their societies and rulers, not to undermine them.
        <br />
        <br />
        <br />
        <br />
        <b>Summary of Today’s Lesson</b>
        <br />
        <br />
        Today's lesson highlighted the balance Islam establishes between
        obedience to rulers and the freedom of individuals in trade and
        financial matters. Muslims are commanded to listen and obey their
        rulers, pray for them, and advise them when needed, but the ruler’s role
        does not extend to monopolizing every aspect of commerce. The Prophet
        (peace be upon him) himself demonstrated that worldly transactions are
        best left to human judgment within the bounds of halal and haram.
        Bitcoin, by design, reflects these principles: it allows markets to
        determine value fairly and transparently while safeguarding wealth from
        riba and manipulation. However, it must never be misused as a
        justification for rebellious behavior. Instead, Bitcoin
        should be seen as a tool of financial sovereignty that strengthens both
        the Muslim individual and the Muslim state, enabling rulers to build
        legitimate, riba-free economies that serve justice and stability.
        
      </p>
      <h2>Test your understanding</h2>
      {questions.map((q, index) => (
        <Question
          key={index}
          questionText={q.text}
          options={q.options}
          correctAnswer={q.correct}
          onAnswer={(value) => handleAnswerChange(index, value)}
        />
      ))}

      <div style={{ marginTop: "20px", fontWeight: "bold", fontSize: "1.2em" }}>
        Score: {score} / {questions.length}
      </div>

      <FloatingPageNav
        prevLink={links.prev}
        indexLink={links.index}
        nextLink={links.next}
      />

    </div>
  );
}

export default IslamicGuide69;
